import {Component, Input} from '@angular/core';
import {PopoverComponent} from "../popover/popover.component";
import { MaterialModule } from "src/app/app.materials";
import { HighlightPipe } from "../../shared/services/highlight.pipe";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-info-popover',
  templateUrl: './info-popover.component.html',
  styleUrls: ['../popover/popover.component.scss'],
  imports: [MaterialModule, HighlightPipe, CommonModule],
  standalone: true,
})
export class InfoPopoverComponent extends PopoverComponent {

  @Input() title = '';
  @Input() content = '';
  @Input() isMAR = false;
  @Input() isCAGR = false;
  @Input() highlight = '';

  @Input() portfolioCreateContent = null;
}
